export default {
  chatbot: {
    toggle_label: "Open Léa assistant",
    close_label: "Close Léa assistant",
    panel_label: "Léa assistant",
    send_label: "Send message",
    stop_label: "Stop generation",
    loading_label: "Léa is typing…",
  },
};
